define(["data/config"], function(config) {
    var apply = function($element) {
        
        $element.on("click", function(ev) {
            toggle($element);
        });

        var toggle = function($element) {
            var $radios = $element.find('.c_uiInputOption__input');
            var $checked = $radios.filter(':checked');
            var $next = $radios.eq($radios.index($checked) + 1);
            if(!$next.length){
                $next = $radios.first();
            }
            $next.prop("checked", true);
        }
    };

    return {
        name: "uiInputOption",
        apply: apply
    };
});
